import { APP_ENV } from '@/enums/globals';
import { StatsigClient, StatsigOptions, StatsigUser } from '@statsig/js-client';

const options: StatsigOptions = {
  environment: { tier: process.env.VUE_APP_ENV || APP_ENV.PRODUCTION },
};

const currentTimestamp = Date.now();
const soloObject: any = JSON.parse(localStorage.getItem('SOLO') as any) || {};
const conceptID: any = soloObject.account?.concept?.id || '';
const userID: any = soloObject.account?.user?.id || null;

const userConfig: StatsigUser = {
  userID: `${userID || currentTimestamp}`,
  customIDs: {
    conceptID: conceptID,
  },
};

const statsigClientInstance = new StatsigClient(process.env.VUE_APP_STATSIG_SECRET_KEY, userConfig, options);

let initialized = false;

export async function getStatsigClient (): Promise<StatsigClient> {
  if (!initialized) {
    await statsigClientInstance.initializeAsync();
    initialized = true;
  }
  return statsigClientInstance;
}

export function checkFeatureFlag (flagName: string, defaultValue = false) {
  return statsigClientInstance.checkGate(flagName) || defaultValue;
}

export function updateStatsigUser (userConfig: StatsigUser) {
  return statsigClientInstance.updateUserSync(userConfig);
}

export async function shutdownStatsigClient () {
  try {
    await statsigClientInstance.shutdown();
    initialized = false;
  } catch (e) {
    console.log('Failed to Shutdown Statsig.');
  }
}
